<div class="messagebox-content">
  <app-svg-icon *ngIf="data.icon !== MessageBoxIcon.None" [name]="svgIcon" class="messagebox-icon"></app-svg-icon>
  <p class="messagebox-text" [innerHTML]="modalRef.modalConfig.stringsAreTranslationKeys ? (data.text | translate) : data.text"></p>
</div>
